import { render, staticRenderFns } from "./NeedReferencesHistory.vue?vue&type=template&id=6fa18b2d"
import script from "./NeedReferencesHistory.vue?vue&type=script&lang=js"
export * from "./NeedReferencesHistory.vue?vue&type=script&lang=js"
import style0 from "./NeedReferencesHistory.vue?vue&type=style&index=0&id=6fa18b2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports